import { NavigationItem } from "../../../core/navigation/types";
import DividendsPage from "./DividendsPage";
import { dividendsLocation, editRouter  } from "./Locations";

export const dividendsComponents: NavigationItem[] = [
  {
    Component: DividendsPage,
    isMenuItem: true,
    path: dividendsLocation,
  },

];
